module.exports = __webpack_public_path__ + "static/images/img_bottom.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_bottom.jpg
// module id = zRL4
// module chunks = 1